import { HoverScaleBackground, hoverScaleProps } from "@Components/common/hover-scale-button";
import Icon from "@Components/generic/icon";
import { faPlusCircle } from "@fortawesome/pro-solid-svg-icons";
import useI18n from "@i18n";
import { Stack, Typography, useTheme } from "@mui/material";
import { CardContainer, CardContent } from "./styled-components";

interface ProfileCardProps {
  name: string;
  avatarUrl?: string;
  league?: string;
  onClick: () => void;
}

export const AddProfileCard = ({ onClick }: { onClick: () => void }) => {
  const { i18n } = useI18n();
  const theme = useTheme();
  return (
    <CardContainer onClick={onClick}>
      <HoverScaleBackground
        {...hoverScaleProps}
        sx={(theme) => ({
          borderRadius: theme.spacing(2.5),
        })}
      />
      <CardContent spacing={3} alignItems="center">
        <Stack 
          justifyContent="center" 
          alignItems="center" 
          sx={(theme) => ({
            width: theme.spacing(12),
            height: theme.spacing(12),
            borderRadius: '50%',
            backgroundColor: theme.palette.dsSurface.v200
          })}
        >
          <Icon icon={faPlusCircle} color={theme.palette.dsSurface.v400} fontSize={32} />
        </Stack>
        <Typography variant="text2xl600" color="dsBase.v200">
          {i18n("account.profile.add.title")}
        </Typography>
      </CardContent>
    </CardContainer>
  );
};

export default AddProfileCard;
